import { Component, inject, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Quotation } from "../../models/quotation.model";
import { QuotationService } from "../../services/quotation.service";
import { QuotationState } from "../../enums/quotation-state.enum";

@Component({
    selector: 'app-delete-shipment-group',
    templateUrl: './delete-quotation.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeleteQuotationComponent implements OnInit {

  public progress = false;
  public error: unknown;
  private quotationService = inject(QuotationService);

  constructor(
    public dialogRef: MatDialogRef<DeleteQuotationComponent>,
    public translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public quotation: Quotation) {
  }

  ngOnInit(): void {
    this.progress = false;
    this.error = null;
  }

  /**
   * Close dialog without any actions
   */
  cancel(): void {
    this.dialogRef.close(null);
  }

  /**
   * Call API to delete the selected shipment group
   */
  async delete(): Promise<void> {
    this.progress = true;
    this.error = null;

    try {
      await this.quotationService.update(this.quotation.id, { state: QuotationState.CANCELED });
      await this.quotationService.createASyncStateTask(this.quotation, QuotationState.CANCELED);
      this.dialogRef.close(true);
    } catch(err) {
      console.error(err);
      this.error = err;
    } finally {
      this.progress = false;
    }
  }
}
